import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SortEvent} from '@shared/table-header-sortable/table-header-sortable.directive';
import {StatusEventGroupPageDisplayDetails} from '@models/pages/status-event-group-page/status-event-group-page-display-details';
import {MenuItem} from '@models/sidebar/menu-item';
import {FilterEvent} from '@models/pages/status-event-group-page/header-filter-event';
import {PaginateControlSettings} from '@models/paginate-control-settings';

@Component({
    selector: 'scitis-status-event-group-page',
    templateUrl: './status-event-group-page.component.html',
    styleUrls: ['./status-event-group-page.component.scss'],
    standalone: false
})
export class StatusEventGroupPageComponent {

  @Input()
  public statusEvents: StatusEventGroupPageDisplayDetails[] = [];

  @Input()
  public menuItemParent: MenuItem = new MenuItem();

  @Input()
  public filtering: FilterEvent = new FilterEvent();

  @Input()
  public paginateSettings: PaginateControlSettings = new PaginateControlSettings();

  @Output()
  private sort: EventEmitter<SortEvent> = new EventEmitter<SortEvent>();

  public onColumnSort(event: SortEvent): void {
    this.sort.emit(event);
  }
}
